import { useDatadogRum } from "@src/utils/datadog";

const deployEnvironment = process.env.DEPLOY_ENVIRONMENT;
const DATADOG_APPLICATION_ID = process.env.DATADOG_APPLICATION_ID ?? "";
const DATADOG_CLIENT_TOKEN = process.env.DATADOG_CLIENT_TOKEN ?? "";

export const useDatadog = () => {
  useDatadogRum({
    allowedTracingUrls: [/^https:\/\/.*\.chime\.com/],
    enabled: process.env.NODE_ENV === "production",
    env: deployEnvironment,
    applicationId: DATADOG_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    service: "identity-client",
    site: "datadoghq.com",
    sessionSampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });
};
